
import { defineComponent } from 'vue'
import { NavItem} from '@/components/atoms'

export default defineComponent({ 
  components: { NavItem}
})
